import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.activeStep)
    ? (_openBlock(), _createBlock($setup["TutorialStep"], {
        key: $setup.activeStep.index,
        step: $setup.activeStep.step,
        first: $setup.activeStep.first,
        last: $setup.activeStep.last,
        stepIndex: $setup.activeStep.index,
        onNext: _cache[0] || (_cache[0] = ($event: any) => ($setup.tutorialStep = $setup.tutorialStep + 1)),
        onBack: _cache[1] || (_cache[1] = ($event: any) => ($setup.tutorialStep = Math.max(0, $setup.tutorialStep - 1))),
        onExitIntro: $setup.exitIntro
      }, null, 8 /* PROPS */, ["step", "first", "last", "stepIndex"]))
    : _createCommentVNode("v-if", true)
}